import { type Campaign } from '@hooks-api/types/dataModel/campaigns'
import { PaymentMethodType, type PaymentMethod } from '@hooks-api/types/dataModel/payment'

export const getDefaultPaymentMethod = (paymentSettings: Campaign['payment_methods'], paymentMethods: PaymentMethod[]) => {
  let firstPaymentSetting = paymentMethods[0]
  if (!firstPaymentSetting) return null
  /** 現在只會有 0, 1，而 1 才是優先的 */
  const sortedPaymentSettings = paymentSettings.sort((a, b) => b.ordinal - a.ordinal)
  for (const setting of sortedPaymentSettings) {
    const defaultPaymentMethod = paymentMethods.find(method => method.type === setting.payment_option_type)
    if (defaultPaymentMethod?.type === PaymentMethodType.APPLE_PAY && !window.ApplePaySession) continue
    if (defaultPaymentMethod) {
      firstPaymentSetting = defaultPaymentMethod
      break
    }
  }
  return firstPaymentSetting
}
